import { AbstractControl, ValidatorFn } from '@angular/forms';

export function phoneNumberValidator() : ValidatorFn {
    return (control : AbstractControl): {[key: string]: any} => {
        const valid = /^(\(?\d{3}\)?)?[\s-]?\d{3}-?\d{4}$/.test(control.value);

        if (!valid) return {
            phoneNumberValidator : 'format'
        };

        return null;
    };
}


// WEBPACK FOOTER //
// ./src/validators/phonenumber.validator.ts